<template>
  <div class="report_builder">
    <v-container>
      <h2 class="mb-2">{{ $store.state.customerName }} ルーティング作成</h2>
      <p>左の部品からドラッグして作成してください。</p>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <v-row>
        <v-col
          cols="12"
          sm="3"
          style="max-height: 500px"
          class="overflow-y-auto"
        >
          <h3 class="mb-2">Form Parts</h3>
          <draggable
            v-model="sampleForms"
            :group="{ name: 'forms', pull: 'clone', put: false }"
            :sort="false"
            :clone="cloneForm"
          >
            <v-card v-for="(form, i) in sampleForms" :key="i" class="mb-4">
              <v-card-title>{{ form.title }}</v-card-title>
              <v-card-text>{{ form.text }}</v-card-text>
            </v-card>
          </draggable>
        </v-col>
        <v-col
          cols="12"
          sm="9"
          style="max-height: 600px"
          class="overflow-y-auto"
        >
          <v-card outlined class="pa-6">
            <!----------------------------------- -->
            <h3 class="mb-2">作成ページ</h3>
            <draggable
              class="droparea"
              v-model="productForms.area"
              :group="{ name: 'forms', pull: true }"
              :options="{ animation: 100 }"
            >
              <!-- v-forでv-btnとv-iconを連続表示  -->
              <div
                class="d-flex align-center tmp"
                v-for="(form, i) in productForms.area"
                :key="i"
              >
                <v-btn
                  @click="modalOpen(form)"
                  block
                  outlined
                  :color="form.noDeploy ? 'orange darken-4' : ''"
                >
                  {{ form.title }}:{{ form.component_name }}
                </v-btn>
                <v-icon @click="removeForm(form, i)" color="grey">
                  fas fa-times
                </v-icon>
                <!-------------------------------------------------->
                <v-dialog v-if="form.dialog" v-model="form.dialog">
                  <page-form
                    v-on:clickSubmit="modalClose"
                    :type="form.type"
                    :position="i"
                    :label="form.label"
                    :init="form.init"
                    :path="form.path"
                    :title="form.title"
                    :noDeploy="form.noDeploy"
                    :component_name="form.component_name"
                    :authrity="form.authrity"
                  ></page-form>
                </v-dialog>
              </div>
            </draggable>
            <!------------------------------------->
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-btn @click="saveForm" color="primary">SAVE</v-btn>
      </v-row>
      <v-row class="ma-1">
        <v-col cols="3">
          <v-file-input
            v-model="importOBJ"
            type="file"
            accept=".json"
            label="jsonインポート"
            prepend-icon="mdi-image"
            ref="rfafile"
            @change="jsonImport"
          ></v-file-input>
        </v-col>
        <v-col cols="3" class="ma-1">
          <v-btn @click="jsonExport">jsonエクスポート</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import PageForm from "../../components/RouterBuilder/PageValue";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
const Encoding = require("encoding-japanese");

export default {
  components: {
    draggable,
    PageForm,
  },
  //data: () => ({
  data() {
    return {
      sampleForms: [
        {
          type: 1,
          title: "選択画面",
          dialog: false,
          text: "選択画面",
          component_name: "Home.vue",
          authrity: 0,
          path: "/",
        },
        {
          type: 2,
          title: "帳票作成・更新",
          dialog: false,
          text: "各ページ",
          component_name: "reportCreate.vue",
          authrity: 0,
          path: "/report/create",
        },
        {
          type: 3,
          title: "帳票一覧",
          dialog: false,
          text: "帳票の一覧を表示",
          component_name: "reportIndex.vue",
          authrity: 0,
          path: "/report/index",
        },
        {
          type: 9,
          title: "帳票一覧(カレンダー形式)",
          dialog: false,
          text: "カレンダー形式で一覧表示する",
          component_name: "calender_index.vue",
          authrity: 0,
          path: "/user/index",
        },
        /*
        type 4 MainMenuで使用済み
        例外コンポーネント、ルーティング対象でないため表示されない
        */
        {
          type: 5,
          title: "CSV取り込みページ",
          dialog: false,
          text: "CSV取り込みページ",
          component_name: "csvImport.vue",
          authrity: 0,
          path: "/csvimport",
        },
        {
          type: 6,
          title: "サブ帳票",
          dialog: false,
          text: "サブ帳票",
          component_name: "subPage.vue",
          authrity: 0,
          path: "",
        },
        {
          type: 7,
          title: "ユーザ情報設定",
          dialog: false,
          text: "ユーザ情報設定",
          component_name: "usersetting.vue",
          authrity: 1,
          path: "/user/setting",
        },
        {
          type: 8,
          title: "ユーザ情報一覧ページ",
          dialog: false,
          text: "ユーザ情報一覧ページ",
          component_name: "userindex.vue",
          authrity: 1,
          path: "/user/index",
        },
        //type: 9,カレンダー形式一覧ページ
        {
          type: 10,
          title: "集計ページ",
          dialog: false,
          text: "集計ページ",
          component_name: "aggregate.vue",
          authrity: 1,
          path: "/view/graph",
        },
        {
          type: 11,
          title: "グラフ出力ページ(サブページ)",
          dialog: false,
          text: "グラフ出力ページ(サブページ)",
          component_name: "graphSub.vue",
          authrity: 1,
          path: "/graph",
        },
        {
          type: 12,
          title: "メール送信ページ",
          dialog: false,
          text: "メール送信設定(帳票作成))",
          component_name: "mailSetting.vue",
          authrity: 1,
          path: "/mail/setting",
        },
        {
          type: 13,
          title: "2段階認証設定ページ",
          dialog: false,
          text: "2段階認証設定ページ",
          component_name: "secondAuth.vue",
          authrity: 1,
          path: "/auth/setting",
        },
        /*  //検討したが、帳票作成でよかった
        {
          type: 14,
          title: "(マスタ形式)登録ページ",
          dialog: false,
          text: "マスタ登録情報による日報作成",
          component_name: "masterCreate.vue",
          authrity: 1,
          path: "/auth/setting",
        },
        */
        {
          type: 15,
          title: "マスタデータ用サブページ",
          dialog: false,
          text: "サブ帳票",
          component_name: "masterSub.vue",
          authrity: 0,
          path: "",
        },
        {
          type: 16,
          title: "一括承認ページ",
          dialog: false,
          text: "特定帳票の一括承認ページ",
          component_name: "batchApproval.vue",
          authrity: 0,
          path: "/approval/index",
        },
        {
          type: 17,
          title: "印刷用ページ",
          dialog: false,
          text: "印刷用別ページ",
          component_name: "printPage.vue",
          authrity: 0,
          path: "/print/",
        },
      ],
      productForms: {
        customerID: 0,
        area: [],
        delete_area: [],
      },
      //
      importOBJ: {},
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      const response = await api.getRouter();
      this.productForms.area = this.respose_convert(response);
      this.$store.state.customerID = Number(this.$route.params.id);
      //読み込み終了
      this.isLoading = false;
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value) => {
        let tmp = {};
        tmp.page_id = value.ID;
        tmp.type = value.page_template_ID;
        tmp.path = value.path;
        tmp.title = value.title;
        tmp.component_name = value.component_name;
        tmp.dialog = false;
        tmp.authrity = value.authrity;
        tmp.noDeploy = value.noDeploy;
        area.push(tmp);
      });
      return area;
    },
    cloneForm: function(obj) {
      //ここが登録される変数
      return {
        path: obj.path,
        title: obj.title,
        component_name: obj.component_name,
        authrity: obj.authrity,
        type: obj.type,
        dialog: obj.dialog,
        noDeploy: false,
      };
    },
    removeForm: function(form, i) {
      form.delete_flag = true;
      this.productForms.delete_area.push(form);
      this.productForms.area.splice(i, 1);
    },
    async saveForm() {
      let data = {};
      data.area = this.productForms.area;
      data.delete_area = this.productForms.delete_area;
      data.customerID = this.$store.state.customerID;
      if (!this.duplicateCehck(data.area)) {
        return;
      }
      try {
        console.log("saveForm", data);
        await api.PageCreate(data);
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    duplicateCehck(data) {
      const path = data.map((obj) => obj.path).filter((path) => path != "");
      const name = data.map((obj) => obj.component_name);
      for (let i = 0; i < path.length; i++) {
        if (path.indexOf(path[i]) != path.lastIndexOf(path[i])) {
          alert(path[i] + "のパス名が重複しています。");
          return false;
        }
      }
      for (let i = 0; i < name.length; i++) {
        if (name.indexOf(name[i]) != name.lastIndexOf(name[i])) {
          alert(name[i] + "のファイル名が重複しています。");
          return false;
        }
      }

      //ファイル名の先頭大文字をチェック
      /*
      const isUpperCase = (c) => {
        return /^[A-Z]+$/g.test(c);
      };
      const firstName = data.filter(
        (obj) => isUpperCase(obj.component_name[0]) && obj.page_id == undefined
      );
      if (firstName.length > 0) {
        alert("ファイル名の先頭に大文字が存在します。");
        return false;
      }
      */
      return true;
    },
    modalOpen: function(form) {
      switch (form.type) {
        default:
          form.dialog = true;
          break;
      }
    },
    modalClose(param) {
      let i = param.position;
      switch (param.type) {
        default:
          this.productForms.area[i].path = param.path;
          this.productForms.area[i].title = param.title;
          this.productForms.area[i].component_name = param.component_name;
          this.productForms.area[i].authrity = param.authrity;
          this.productForms.area[i].noDeploy = param.noDeploy;
          //
          this.productForms.area[i].dialog = false;
          break;
      }
    },
    back() {
      history.back();
    },
    //jsonインポート関連------------------------------------------------------
    async jsonImport(file) {
      try {
        //文字コード変換
        const data = await this.charCodeConvert(file);
        const json = JSON.parse(data);
        json.forEach((j) => {
          j.page_id = 0;
        });
        //格納
        this.productForms.area = json;
      } catch (e) {
        console.log(e);
      }
    },
    jsonExport() {
      const json = JSON.stringify(this.productForms.area, null, 2);
      let blob = new Blob([json], { type: "text/json" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "cusotomrtID_" + this.productForms.customerID + ".json";
      link.click();
    },
    charCodeConvert(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          //文字列をバイト列に変換
          var sjisArray = new Uint8Array(reader.result);
          //encode.jsを使い、文字コードを自動判別しUNICODEへ変換
          var unicodeArray = Encoding.convert(sjisArray, {
            to: "UNICODE",
            from: "AUTO",
            type: "string",
          });
          resolve(unicodeArray);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
